// extracted by mini-css-extract-plugin
module.exports = {"root":"FullWidthHighlighted-module--root--2l-G6","title":"FullWidthHighlighted-module--title--sZU6E","description":"FullWidthHighlighted-module--description--2dZ15"};